import React from 'react';
import styled from 'styled-components';
import Image from 'gatsby-theme-employees/src/components/preview/image';

const ImageComponent = ({ className, ...props }) => (
  <div className={className}>
    <Image {...props} />
  </div>
);

export default styled(ImageComponent)`
  width: 100%;
  position: relative;
  overflow: hidden;
  margin-bottom: 1rem;

  &:empty {
    background-color: ${({ theme }) => theme.primaryColor};
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
